<script lang="ts">
  /**
   * Imports
   * ---------------------------------------------------------------------------
   */

  import { convertStatamicAssetToCDN } from "@utils/cdn";
  import LayeredSection from "@components/layout/LayeredSection.svelte";
  import type { StatamicAsset } from "@customTypes/statamic";
  import clsx from "clsx";

  /**
   * Props
   * ---------------------------------------------------------------------------
   */

  /** title text */
  export let title: string;

  /** subtitle text */
  export let subtitle: string | undefined;

  /** image data */
  export let image: StatamicAsset;

  /**
   * Data
   * ---------------------------------------------------------------------------
   */

  const isImageSet = !!image?.id;
  const isSubtitleSet = !!subtitle;
</script>

<!-- Template ----------------------------------------------------------------->

<LayeredSection
  addClasses={clsx(
    "box-border flex h-screen max-h-[350px] items-start justify-center bg-cover bg-center text-center ",
    isImageSet && "max-h-[450px] ",
    !isImageSet && "items-end",
    !isImageSet && isSubtitleSet && "max-h-[250px]",
    !isImageSet && !isSubtitleSet && "min-h-[200px]",
  )}
  layers={[
    {
      halfscreenBackgroundImage: {
        asset: image,
        // pictureClasses: "absolute w-full h-full",
      },
    },
    {
      backgroundCSS:
        "background: linear-gradient(rgba(0, 0, 0, 0) 70%, rgba(0, 0, 0, 1) );",
    },
  ]}
>
  <div
    class={`text-white z-10 flex h-full w-full flex-col items-center justify-center container`}
  >
    <h1 class="pt-4 wah-heading-1">{title}</h1>
    {#if subtitle}
      <p class="pt-4 wah-hero-2">{subtitle}</p>
    {/if}
  </div>
</LayeredSection>
